

import { Tabs } from "antd";
import { AgTableClient } from "app/shared/AgTable";
import PageHeader from "app/shared/PageHeader";
import { useState, useEffect,useRef, useMemo } from "react";
import axios from "axios";
import { format } from "path";
import Typography from "app/shared/Typography";
import { COUNTRY_ISO_MAP } from "../../vat.globa.constant";
import { CheckCircleFilled } from "@ant-design/icons";
import { PercentageOutlined } from "@ant-design/icons";
import { CloseCircleFilled } from "@ant-design/icons";
import { getProcessedDefinition } from "app/utils/generic.helper";
import { useRecoilState } from "recoil";
import {
    userInfo
} from "app/config/States/users";

const GovernmentRules = () => {
    const [activeTab, setActiveTab] = useState<TabKey>("1");
    const [rowData, setRowData] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const gridRef = useRef<any>(null);
    const [columnDefs, setColumnDefs] = useState<any[]>([]);
    const [userDetails, _] = useRecoilState<any>(userInfo);

    const items = [
        {
            key: "1",
            label: "Domestic Registration",
        },
        {
            key: "2",
            label: "8th Directive",
        },
        {
            key: "3",
            label: "13th Directive",
        },
    ];

    const API_MAP: Record<TabKey, { url: string; key: string }> = {
        "1": {
            url: "https://stage-apiplatform.finkraftai.com/api/vatTable/getTableDataClientSide",
            key: "matchedData",
        },
        "2": {
            url: "https://stage-apiplatform.finkraftai.com/api/vatTable/getTableDataClientSide",
            key: "unmatchedData",
        },
        "3": {
            url: "https://stage-apiplatform.finkraftai.com/api/vatTable/getTableDataClientSide",
            key: "manualData",
        },
    };


    type TabKey = "1" | "2" | "3";

    const TABLE_NAME_MAP: Record<TabKey, string> = {
        "1": "hotel_recon_registration",
        "2": "hotel_recon_8_directive",
        "3": "hotel_recon_13_directive",
    };
    const MODULE_ID_MAP: Record<TabKey, string> = {
        "1": "Domestic Registration",
        "2": "8th Directive",
        "3": "13th Directive",
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
    
                const { url } = API_MAP[activeTab as TabKey];
                const tableName = TABLE_NAME_MAP[activeTab as TabKey];
                const moduleId = MODULE_ID_MAP[activeTab as TabKey]; // ✅ human-readable module id
    
                // Fetch rowData
                const response = await axios.post(url, { tableName });
                const apiData = response.data?.data?.data?.map((item: any) => ({
                    ...item,
                    tableName,
                })) || [];
                setRowData(apiData);
    
                // Fetch columnDefs for this tab
                const colResponse = await axios.post(
                    "https://stage-apiplatform.finkraftai.com/api/vatTable/getColumnSchema",
                    { moduleId }
                );
                const cols = colResponse?.data?.data?.data?.state?.columnDefs || [];
                setColumnDefs(cols);
    
            } catch (err) {
                setRowData([]);
                setColumnDefs([]);
            } finally {
                setLoading(false);
            }
        };
    
        fetchData();
    }, [activeTab]);


    
    


    const processedColumnDefs = useMemo(() => {
        if (!columnDefs || columnDefs.length === 0) return [];
        const defs = getProcessedDefinition(columnDefs, "CLIENT", userDetails || {});
        return defs;
    }, [columnDefs, userDetails]);
    
    useEffect(() => {
        if (gridRef.current && processedColumnDefs.length > 0) {
            gridRef.current.api.setColumnDefs(processedColumnDefs);
        }
    }, [processedColumnDefs]);



    return (
        <div style={{ height: "100%", display: 'flex', flexDirection: "column" }}>
            <PageHeader
                leftActions={
                    <Tabs
                        items={items}
                        tabBarStyle={{
                            borderBottom: "none", // Remove the underline border
                            margin: 0,
                        }}
                        activeKey={activeTab}
                        onChange={(tabItem: string) => setActiveTab(tabItem as TabKey)}

                    />
                }
                 showWorkspaceDropdown={false}
            />
            <div style={{ flex: 1 }}>
                <AgTableClient
                    //@ts-ignore
                    columnDefs={processedColumnDefs}
                    rowData={rowData}
                    groupPanel
                    defaultPivot={[""]}
                    // grandTotalRow
                    enablePDFViewer
                    // showExport
                />
            </div>
        </div>
    );
};

export default GovernmentRules;

